var App = App || {};

App.Parallax = (function ($) {

    'use strict';

    function Parallax() {
        const divisor = 2;

        $(".widget-homepage-banner").each(function () {
            $(this).children(".widget-homepage-watermark").ZagParallax({ divisor: divisor });
        });

        $(".site-main").each(function () {
            $(this).children(".widget-masthead-watermark").ZagParallax({ divisor: divisor });
        });

        $(".blog-masthead").each(function () {
            $(this).children(".widget-masthead-watermark").ZagParallax({ divisor: divisor });
        });

        $(".site-main").each(function () {
            $(this).children(".page-default-watermark").ZagParallax({ divisor: divisor });
        });

        $(".site-main").each(function () {
            $(this).children(".page-landing-watermark").ZagParallax({ divisor: divisor });
        });

        $(".site-main").each(function () {
            $(this).children(".bios-watermark").ZagParallax({ divisor: divisor });
        });

        $(".category-compare-wrapper").each(function () {
            $(this).children(".zag-parallax-bg").ZagParallax({ divisor: divisor });
        });

        $(".landing-masthead").each(function () {
            $(this).children(".zag-parallax-bg").ZagParallax({ divisor: divisor });
        });

        $(".widget-video").each(function () {
            $(this).children(".zag-parallax-bg").ZagParallax({ divisor: divisor });
        });

        $(".widget-content-cards").each(function () {
            $(this).children(".widget-cc-watermark").ZagParallax({ divisor: divisor });
        });
    }

    return {
        Parallax: Parallax
    };

})(jQuery);

$(function () {
    App.Parallax.Parallax();
});